export default __webpack_public_path__ + "static/media/auprop.b951a190.png";